import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const buyProductService = async (
  userToken: string,
  product_id: string | number,
  payWithWallet:number,
  payWithGiftWallet:number,
) => {
  const data = new FormData();
  data.append("product_id", String(product_id));
  data.append("pay_with_wallet", String(payWithWallet));
  data.append("pay_with_gift_wallet", String(payWithGiftWallet));
  return axiosV3.post("/buy_product", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
